import React from 'react';
import Navigation from './Navigation'; 
import logo from '../assets/logo.png'; // 会社ロゴ
import ArrowIcon from './ArrowIcon';
import './Footer.css';

function Footer() {
  return (
    <>
      {/* 独立した帯（文字のみカラー） */}
      <div className="footer-tagline-bar">
        世界をもっとビビッドに。
      </div>

      {/* フッター本体 */}
      <footer className="footer-section">
        <div className="footer-content-left">
          <img src={logo} alt="会社ロゴ" className="footer-company-logo" />
          <nav className="footer-links">
            <ul>
              <li><a href="https://shop.wonder-story.jp/pages/privacy-policy" target="_blank" rel="noreferrer">PrivacyPolicy/</a></li>
              <li><a href="https://form.run/@tohakusha-v4eFrsWHhCyIoHmhe5iK" target="_blank" rel="noreferrer">Contact/</a></li>
              <li><a href="https://hrmos.co/pages/tohakusha" target="_blank" rel="noreferrer">Recruit</a></li>
            </ul>
          </nav>
          <span
            className="footer-arrow-wrap"
            onClick={() => {
              const heroSection = document.getElementById('hero');
              if (heroSection) {
                heroSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            <ArrowIcon className="footer-arrow-icon" />
          </span>
        </div>

        <div className="footer-content-right">
          <Navigation position="footer" />
        </div>
      </footer>
    </>
  );
}

export default Footer;
